export default function CoreCompetitiveness() {
  const advantages = [
    {
      icon: 'ri-landscape-line',
      title: 'No Foundation Required',
      description: 'Adaptable to all terrain types without excavation or concrete foundation work',
      color: 'from-gray-500/20 to-slate-500/20'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Zero Environmental Impact',
      description: 'No damage to ecological environment, no construction waste, fully reversible installation',
      color: 'from-emerald-500/20 to-teal-500/20'
    },
    {
      icon: 'ri-timer-flash-line',
      title: 'Rapid Installation',
      description: 'Integral prefabrication enables 48-hour on-site installation with minimal disruption',
      color: 'from-amber-500/20 to-orange-500/20'
    },
    {
      icon: 'ri-truck-line',
      title: 'Complete Transportation',
      description: 'Overall unit transport, convenient assembly and disassembly, ready for immediate use',
      color: 'from-blue-500/20 to-indigo-500/20'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Flexible Land Use',
      description: 'Easy relocation and redeployment, perfect for temporary or evolving business needs',
      color: 'from-purple-500/20 to-pink-500/20'
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Modular Scalability',
      description: 'Expandable design allows multiple units to connect for growing workspace requirements',
      color: 'from-rose-500/20 to-red-500/20'
    }
  ];

  return (
    <section className="py-16 sm:py-20 lg:py-24 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-transparent to-[#0A0A0A] w-full">
      <div className="max-w-7xl mx-auto w-full">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16 lg:mb-20">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-thin mb-4 sm:mb-6 px-4">
            Why Choose <span className="text-gray-300">A Series</span>
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-400 max-w-3xl mx-auto px-4">
            Unmatched advantages for modern workspace solutions
          </p>
        </div>

        {/* Advantages Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 w-full">
          {advantages.map((advantage, index) => (
            <div
              key={index}
              className="group relative bg-gradient-to-br from-white/5 to-white/[0.02] backdrop-blur-xl border border-gray-500/20 rounded-2xl p-6 sm:p-8 transition-all duration-500 cursor-pointer w-full hover:border-gray-400/50 hover:shadow-[0_0_30px_rgba(148,163,184,0.15)]"
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${advantage.color} opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-2xl`}></div>
              
              <div className="relative z-10">
                <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-xl sm:rounded-2xl flex items-center justify-center mb-4 sm:mb-6 transition-all duration-500 bg-white/10">
                  <i className={`${advantage.icon} text-2xl sm:text-3xl text-gray-400`}></i>
                </div>
                
                <h3 className="text-xl sm:text-2xl font-medium mb-3 sm:mb-4 text-white break-words">{advantage.title}</h3>
                <p className="text-sm sm:text-base text-gray-400 leading-relaxed mb-4 sm:mb-6 break-words">{advantage.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Feature Bar */}
        <div className="mt-16 bg-gradient-to-r from-gray-500/10 to-slate-500/10 border border-gray-500/20 rounded-2xl p-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl font-light text-gray-300 mb-2">15+</div>
              <div className="text-sm text-gray-500">Years Service Life</div>
            </div>
            <div>
              <div className="text-4xl font-light text-gray-300 mb-2">100%</div>
              <div className="text-sm text-gray-500">Factory Prefabricated</div>
            </div>
            <div>
              <div className="text-4xl font-light text-gray-300 mb-2">IP65</div>
              <div className="text-sm text-gray-500">Weather Protection</div>
            </div>
            <div>
              <div className="text-4xl font-light text-gray-300 mb-2">A+</div>
              <div className="text-sm text-gray-500">Energy Efficiency</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}